@if (currentPodcast() && showPlayer()) {
  <div class="fixed bottom-4 md:right-4 w-96 bg-white shadow-lg rounded-lg overflow-hidden z-50">
    <app-podcast-list-item
      class="flex flex-col lg:flex-row w-full"
      [alternativeDatePoisition]="true"
      [hideLinkArrows]="true"
      [podcast]="currentPodcast()"
      [showCloseButton]="true"
      [showImage]="false"
      [smallCompanyName]="true"></app-podcast-list-item>
  </div>
}
